"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketSubscriptionConfig = exports.getDefaultReplyEmail = exports.getDefaultSite = exports.APPLE_APP_STORE_LINK = exports.GOOGLE_PLAY_STORE_LINK_ANDROID = exports.GOOGLE_PLAY_STORE_LINK = void 0;
var languages_1 = require("./i18n/languages");
exports.GOOGLE_PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.visikon.mitforlob';
exports.GOOGLE_PLAY_STORE_LINK_ANDROID = 'market://details?id=com.visikon.mitforlob';
exports.APPLE_APP_STORE_LINK = 'https://itunes.apple.com/app/id985602544';
var getSiteFromLanguage = function (languageCode) { var _a; return ((_a = languages_1.Domains.find(function (d) { return d.language === languageCode; })) === null || _a === void 0 ? void 0 : _a.sites[0]) || languages_1.DefaultSite; };
function getDefaultSite(languageCode) {
    var site = getSiteFromLanguage(languageCode);
    return "https://".concat(site);
}
exports.getDefaultSite = getDefaultSite;
var getDefaultReplyEmail = function (languageCode) {
    var site = getSiteFromLanguage(languageCode);
    return "no-reply@".concat(site);
};
exports.getDefaultReplyEmail = getDefaultReplyEmail;
exports.SocketSubscriptionConfig = {
    subscribeEvent: 'documents:subscribe',
    unsubscribeEvent: 'documents:unsubscribe',
    documentUpdatedEventPrefix: 'documents:updated:',
};
//# sourceMappingURL=misc.js.map